/** The till's dialogs: bill discount, hold and resume, open and close shift, No Tax, open items. */
export default {
  'discount.title': 'Bill discount',
  'discount.limit': 'You may discount up to {percent}% of the bill',
  'discount.noRight': 'Your role cannot give a bill discount. A manager must approve it.',
  'discount.none': 'No discount',
  'discount.percent': 'Percent',
  'discount.amount': 'Flat amount',
  'discount.percentOff': 'Percent off',
  'discount.percentLabel': 'Discount percent',
  'discount.beyond': '{requested}% is beyond your {limit}% limit. Ask a manager to apply it.',
  'discount.amountLabel': 'Flat amount (₹)',
  'discount.amountAria': 'Discount amount in rupees',
  'discount.subtotal': 'Bill subtotal is ₹{amount}.',

  'hold.title': 'Hold and resume',
  'hold.subtitle': 'Held bills do not touch stock',
  'hold.name': 'Name this bill (optional)',
  'hold.label': 'Hold label',
  'hold.submit': 'Hold this bill',
  'hold.emptyBill': 'The current bill is empty, so there is nothing to hold. Resume one below.',
  'hold.holdFirst': 'Hold this bill first to resume another one.',
  'hold.list': 'Held on this terminal',
  'hold.loading': 'Loading held bills…',
  'hold.none': 'Nothing is held.',
  'hold.items': { one: '{count} item', other: '{count} items' },
  'hold.resumeLabel': 'Resume {name}',
  'hold.resume': 'Resume',

  'shift.openTitle': 'Open shift',
  'shift.openSubtitle': 'Count the float in the drawer before the first bill.',
  'shift.opening': 'Opening…',
  'shift.openingCash': 'Opening cash (₹)',
  'shift.closeTitle': 'Close shift',
  'shift.closeSubtitle': 'Count the cash in the drawer and enter the total.',
  'shift.closing': 'Closing…',
  'shift.loadFailed': 'Could not load the shift totals.',
  'shift.closeFailed': 'Could not close the shift.',
  'shift.opened': 'Opening cash',
  'shift.cashSales': 'Cash sales',
  'shift.cashRefunds': 'Cash refunds',
  'shift.expected': 'Expected in drawer',
  'shift.loading': 'Loading shift totals…',
  'shift.counted': 'Counted cash (₹)',
  'shift.balances': 'Drawer balances.',
  'shift.short': 'Short by ₹{amount}',
  'shift.over': 'Over by ₹{amount}',
  'shift.reason': 'Reason for the difference (required)',

  'noTax.title': 'No Tax on this bill',
  'noTax.apply': 'Remove tax',
  'noTax.reason': 'Reason (optional)',
  'noTax.becomes': '₹{from} becomes ₹{to}',
  'noTax.pays': 'The customer pays ₹{amount}, ₹{less} less.',
  'noTax.asDiscount': 'The invoice still shows GST inside the price, with the reduction as a discount.',
  'noTax.asExempt': 'The invoice shows no tax and is marked "Tax exempt bill".',
  'noTax.reasonAria': 'Reason for removing tax',
  'noTax.audit': 'Recorded in the audit trail with your name.',

  'openItem.title': 'Open item',
  'openItem.subtitle': 'An item that is not in the catalogue. It does not change stock.',
  'openItem.name': 'Name',
  'openItem.price': 'Price each (₹)',
  'openItem.qty': 'Quantity',
  'openItem.add': 'Add to bill',
  'openItem.nameAria': 'Open item name',
  'openItem.priceAria': 'Open item price',
  'openItem.qtyAria': 'Open item quantity',
  'openItem.priceProblem': 'Enter a price above zero.',
  'openItem.qtyProblem': 'Use a whole number of items.',
  'openItem.overLimit': '₹{amount} is above the ₹{limit} open-item limit. A manager must enter it.',
  'openItem.noTax': 'No tax is added. Use Item Tax to add one to this item.',

  'itemTax.title': 'Item tax',
  'itemTax.none': 'No tax',
  'itemTax.inclusive': 'The price typed already includes the tax: the total stays the same.',
  'itemTax.onTop': 'The tax is added on top of the price typed.',
  'itemTax.for': 'Tax for {name}',

  // weigh pad
  'weigh.title': 'Weigh {name}',
  'weigh.subtitle': 'Type a weight, or what the customer wants to spend',
  'weigh.rate': '₹{rate} per {unit} · GST {percent}%',
  'weigh.amountAria': 'Amount in rupees',
  'weigh.keypad': 'Keypad',
  'weigh.decimal': 'Decimal point',
  'weigh.onShelf': '{qty} {unit} on the shelf',
  'weigh.by': 'Weigh by',
  'weigh.byWeight': 'By weight',
  'weigh.byAmount': '₹ By amount',
  'weigh.weightIn': 'Weight in {unit}',
  'weigh.askedFor': 'Customer asked for (₹)',
  'weigh.backspace': 'Delete the last digit',
  'weigh.overShelf': 'That is more than the {qty} {unit} the system shows on the shelf. Check the shelf before billing it.',
  'weigh.add': 'Add {qty} {unit} · ₹{amount}',
  'weigh.enter': 'Enter a weight or an amount',

  // phone camera scanner
  'camera.title': 'Scan with camera',
  'camera.preview': 'Camera preview appears here. Nothing is recorded.',
  'camera.starting': 'Starting…',
  'camera.start': 'Start camera',
  'camera.stop': 'Stop camera',
  'camera.rear': 'Rear camera (auto)',
  'camera.torchOff': 'Torch off',
  'camera.torchOn': 'Torch on',
  'camera.again': 'Scan again',
  'camera.last': 'Last decoded:',
  'camera.paused': 'Capture paused while payment is open.',
  'camera.camera': 'Camera',
  'camera.zoom': 'Zoom',
  'camera.unsupported': 'This device or browser cannot open a camera here. The hardware scanner and manual entry keep working.',
  'camera.denied': 'Camera access was denied. Allow camera for this site in the browser settings, then try again — or keep using the hardware scanner.',
  'camera.none': 'No camera was found on this device. Use the hardware scanner or type the code.',
  'camera.inUse': 'The camera is busy in another app or tab. Close it there and retry.',
  'camera.decoder': 'This browser has a camera but no barcode reader. Use the hardware scanner or manual entry.',
  'camera.unknown': 'The camera could not start. Use the hardware scanner or manual entry.',
} as const;
